/*

FILE: dom.js
DESCRIPTION: Re-usable functions with DOM side-effects
AUTHOR(S): R.J. LaCount

*/

const loadMore = (target) => {
	const section = target.closest('section');
	target.classList.add('hidden');
	section.querySelector('.secondary-load').classList.remove('hidden');
}

export { loadMore };
